const ACTIVE_PERIOD_STATUS = 'active'

const asObject = (value) =>
  value && typeof value === 'object' && !Array.isArray(value) ? value : {}

const asFiniteNumber = (value) => {
  const number = Number(value)
  return Number.isFinite(number) ? number : 0
}

export const normalizePlanetHdResellerContext = (payload) => {
  const root = asObject(asObject(payload).data || payload)
  const providerPeriod = asObject(root.provider_period || root.providerPeriod)
  const reseller = asObject(root.reseller)
  const providerPeriodId = String(
    providerPeriod.provider_period_id || providerPeriod.providerPeriodId || ''
  ).trim()
  const status = String(providerPeriod.status || '')
    .trim()
    .toLowerCase()

  return {
    providerPeriod: {
      providerPeriodId,
      startAt: providerPeriod.start_at || providerPeriod.startAt || null,
      endAt: providerPeriod.end_at || providerPeriod.endAt || null,
      status,
    },
    reseller: {
      assignedHa: asFiniteNumber(reseller.assigned_ha ?? reseller.assignedHa),
      coveredHa: asFiniteNumber(reseller.covered_ha ?? reseller.coveredHa),
      reservedHa: asFiniteNumber(reseller.reserved_ha ?? reseller.reservedHa),
      availableHa: asFiniteNumber(reseller.available_ha ?? reseller.availableHa),
    },
    canAssign: Boolean(providerPeriodId && status === ACTIVE_PERIOD_STATUS),
  }
}
